/**
 * Every `string[]` + `facet: true` field on the jobs schema (see JOB_FIELDS_BASE in
 * collection-schemas.ts), mapped to its companion `<field>Count` field name.
 *
 * Typesense's `filter_by` has no array-length or set-equality operator — `field:=value`
 * only tests membership. An "only" filter ("requiredLanguages is English and nothing
 * else") is expressed as `requiredLanguages:=English && requiredLanguagesCount:=1`, so
 * every array facet that wants "only" support needs this companion count field indexed
 * alongside it. This map is the single source of truth for which facets qualify —
 * consumed by the schema, the indexer, the query builders, and the filter UI, so "only"
 * can never be offered on a scalar facet (e.g. companyId, jobType) where it wouldn't mean
 * anything.
 *
 * `specialisations` is `string[]` but not `facet: true` (not filterable at all today), so
 * it's intentionally excluded.
 */
export const ARRAY_FACET_COUNT_FIELD: Readonly<Record<string, string>> = {
  normalisedRoleLevel: 'normalisedRoleLevelCount',
  field: 'fieldCount',
  educationLevel: 'educationLevelCount',
  companyIndustry: 'companyIndustryCount',
  locationList: 'locationListCount',
  benefits: 'benefitsCount',
  skillsAndTechnologies: 'skillsAndTechnologiesCount',
  requiredLanguages: 'requiredLanguagesCount',
  optionalLanguages: 'optionalLanguagesCount',
};

export function supportsOnlyFilterMode(attribute: string): boolean {
  return Object.prototype.hasOwnProperty.call(ARRAY_FACET_COUNT_FIELD, attribute);
}
